export default __webpack_public_path__ + "static/media/sportsbook2.4f94476d.svg";